import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import { browserHistory } from 'react-router'
// import injectTapEventPlugin from 'react-tap-event-plugin'
import { syncHistoryWithStore } from 'react-router-redux'
import { AppContainer } from 'react-hot-loader'
import configureStore from './state/configureStore'
import Root from './containers/root'
import './web.config'
const store = configureStore()

const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState(state) {
    return state.routing
  }
})

//---App initialization

/**
 * we require next line to support onTouchTap event
 * which will solve a lot of "click" problems for mobile devices
 */
// injectTapEventPlugin()

render(
  <AppContainer>
    <Root history={history} store={store} />
  </AppContainer>,
  document.getElementById('root')
)

//---Hot Module Replacement
if (module.hot) {
  module.hot.accept('./containers/root', () => {
    const NextApp = require('./containers/root').default

    render(
      <AppContainer>
        <NextApp history={history} store={store} />
      </AppContainer>,
      document.getElementById('root')
    )
  })
}



// WEBPACK FOOTER //
// ./index.js